import React, { useState } from "react";
import styles from "./index.module.css";
import {
  Grid,
  Hidden,
} from "@material-ui/core";
import Sidebar from "./sidebar";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import FacultyProfile from "./Faculty_Profile";
import AOtoCOMappingReportCourseWise from "./AO_to_CO_Mapping_Report_Course-wise";
import CIATEEQuestionPaperReportCourseWise from "./CIA_TEE_Question_Paper_Report_Course-wise";
import CourseDomainReport from "./Course_Domain_Report";
import DepartmentCurriculumReport from "./Department_Curriculum_Report";
import LabLessonPlanReport from "./Lab_Lesson_Plan_Report";
import MappingReport from "./Mapping_Report";
import ProgramArticulationMatrixReport from "./Program_Articulation_Matrix_Report";
import ProgramLevelCourse from "./Program_Level_Course";
import StudentImprovementPlanReport from "./Student-Improvement_Plan_Report";
import TermWiseCourseReport from "./Term-wise_Course_Report";
import TextReferenceBookList from "./Text_Reference_Book List";
import TheoryLessonPlanReport from "./Theory_Lesson_Plan_Report";
import TransposeProgramArticulationMatrix from "./Transpose_Program_Articulation_Matrix";
import UnmappedPOReport from "./Unmapped_PO_Report";


const Index = () => {
  return (
    <Router>
      <Grid container>
        <Hidden mdDown>
          <Grid item lg={3} className={styles.sidebarWrapper}>
            <Sidebar />
          </Grid>
        </Hidden>
        <Grid item lg={9}>
          <Switch>
          <Route exact path="/reports" component={FacultyProfile} />
          <Route exact path="/reports/ao-mapping" component={AOtoCOMappingReportCourseWise} />
          <Route exact path="/reports/cia-question" component={CIATEEQuestionPaperReportCourseWise} />
          <Route exact path="/reports/course-domain-report" component={CourseDomainReport} />
          <Route exact path="/reports/department-curr" component={DepartmentCurriculumReport} />
          <Route exact path="/reports/lab-lesson" component={LabLessonPlanReport} />
          <Route exact path="/reports/mapping-report" component={MappingReport} />
          <Route exact path="/reports/program-art" component={ProgramArticulationMatrixReport} />
          <Route exact path="/reports/program-level" component={ProgramLevelCourse} />
          <Route exact path="/reports/student-imp" component={StudentImprovementPlanReport} />
          <Route exact path="/reports/termwise-course" component={TermWiseCourseReport} />
          <Route exact path="/reports/text-ref" component={TextReferenceBookList} />
          <Route exact path="/reports/theory-lesson" component={TheoryLessonPlanReport} />
          <Route exact path="/reports/transpose-prog" component={TransposeProgramArticulationMatrix} />
          <Route exact path="/reports/unmapped-report" component={UnmappedPOReport} />
            
           
          </Switch>
        </Grid>
      </Grid>
    </Router>
  );
};

export default Index;
